export default __webpack_public_path__ + "static/media/star-editions.800683ed.webp";